module.exports = __webpack_public_path__ + "static/img/chatbotIcon-loading.77efd899.gif";